<div class="main-wrapper">
@if (this.readOnly()) {
<div>Dip: {{this.value()}}</div>

} @else {
<kendo-label [text]="'Dip: '">
    <kendo-numerictextbox [value]="this.value()" [min]="0" format="n0" [size]="'small'" [style]="{ width: '70px' }"
        (valueChange)="onValueChanged($event)"></kendo-numerictextbox>
</kendo-label>
}
<div class="dip" [class.readonly]="this.readOnly()">
    <div class="dip-wrapper">
        @for (b of this.bitsArray(); track $index) {
        <div class="dip-bit">
            <kendo-label [text]="'' + ($index + 1)"></kendo-label>
            <kendo-switch onLabel="" offLabel="" (valueChange)="onSwitchChanged($event, $index)" [checked]="b == 0"
                [readonly]="this.readOnly()" [size]="'none'" class="kswitch-dip" [trackRounded]="'none'"
                [thumbRounded]="'none'" />

        </div>
        }
    </div>
    <div class="on-label">On</div>
</div>
</div>